<template>
  <div class="animated fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-12 pt-2 pb-3 pl-4">
          <h3><i class="fas fa-map-marked-alt"></i> Módulo de Visitas <small style="font-size: 18px;">| Registrar Deslocamento</small></h3>
          <small>Acompanhe, planeje e registre suas visitas.</small>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12">
          <Forms ref="frmGroup"
            :title="'REGISTRAR CHECK-OUT'"
            :showClearButton="true"
            :showSaveButton="true"
            :showBackButton="true"
            v-on:Clear="onClear"
            v-on:Back="onBack"
            v-on:Save="onSave">
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label for="txtDescription"><small v-show="form.comentario.required" class="text-danger">*</small> Comentário:</label>
                <b-form-textarea
                  v-model="form.comentario.value"
                  :placeholder="'Digite como foi a visita, por favor'"
                  :rows="form.comentario.rows"
                  :maxlength="form.comentario.maxlength"
                  :noResize="form.comentario.noResize"></b-form-textarea>
                <small class="small-help"><i class="fas fa-microphone"></i> utilize o microfone no teclado do celular para registrar o comentário (voz para texto).</small>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label ><small class="text-danger">*</small> Local:</label>
                <div class="input-group" style="border: solid 1px #d6d6d6">
                  <Map
                    v-if="data.deslocamentoId !== null"
                    ref="map"
                    style="width: 100%; height: 400px;"
                    @initialized="onInitialized"
                    @change:location="handleCoords"
                  />
                </div>
              </div>
            </div>
          </Forms>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img src="/static/img/bg/world_re_768g.svg" style="width: 40%; opacity: 0.2"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'

import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'

import Map from '../../components/Map.vue'

const form = {
  comentario: {
    value: '',
    rows: 8,
    maxlength: 500,
    required: true,
    noResize: true
  }
}
const data = {
  id: null,
  deslocamentoId: null,
  comentario: '',
  latitudeFinal: null,
  longitudeFinal: null,
  coordsTempoReal: null
}

export default {
  name: 'CheckOut',
  mixins: [ActionsForm],
  components: { Map },
  data () {
    return {
      data: data,
      form: form
    }
  },
  async mounted () {
    loading.push()
    Tools.MinimizedSidebar()
    await this.getDeslocamento()
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Visitas' })
    },
    onInitialized () {
      loading.pop()
    },
    async handleCoords () {
      const currentCoords = await this.$refs.map.getCurrentLocation()

      this.data.coordsTempoReal = this.data.coordsTempoReal === null
      this.data.latitudeFinal = currentCoords.latitude
      this.data.longitudeFinal = currentCoords.longitude
    },
    async getDeslocamento () {
      const response = await DeslocamentoRepository.GetActive()

      if (response.data === '') {
        this.onBack()
        return
      }

      const visita = response.data.visitas.find(v => v.dataCheckOut === null)

      if (visita === null) {
        this.onBack()
        return
      }

      this.data.id = visita.id
      this.data.deslocamentoId = response.data.id
    },
    async onUpdate () {
      if (this.data.latitudeFinal === null) {
        toast.warning('Geolocalização é necessária para iniciar o deslocamento')
        return
      }

      if (this.data.deslocamentoId === null) {
        toast.warning('Não há um deslocamento em andamento para fazer check-out')
        return
      }

      try {
        loading.push()
        await DeslocamentoRepository.CheckOut(this.data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.onBack()
      } catch (error) {
        toast.error(this.$lang.Common.Alerts.Error)
      } finally {
        loading.pop()
      }
    }
  }
}
</script>
<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4 {
  font-size: 1.25rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/register/checkout.vue